import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate } from "react-router-dom";
import debounce from 'lodash/debounce';
import CohortAssortmentListComponent from "./component";

const CohortAssortmentListContainer = (props) => {
  const navigate = useNavigate();
  const [assortmentCohortMetaDataList, setAssortmentCohortMetaDataList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(50);
  const [hasMore, setHasMore] = useState(false);

  const handleWarehouseClick = (reference_id) => {
    navigate(`/home/assortment/assortmentcohortlistdetails/${reference_id}`);
  };

  // Initial load
  // useEffect(() => {
  //   fetchCohortList("", 0);
  // }, []);

  // Search with debounce
  useEffect(() => {
    const debouncedSearch = debounce(() => {
      setPage(0); // Reset to first page on new search
      fetchCohortList(searchTerm, 0);
    }, 500);

    debouncedSearch();

    return () => debouncedSearch.cancel();
  }, [searchTerm]);

  const fetchCohortList = (query = "", pageNum = 0) => {
    setLoading(true);
    
    
    let apiUrl = `/partner/api/v1/assortment/cohort/metadata?page=${pageNum}&size=${size}`;
    

    if (query && query.trim() !== "") {
      apiUrl += `&search=${encodeURIComponent(query.trim())}`;
    }

    props.getDataFromAPI(
      apiUrl,
      "GET",
      undefined,
      (response) => {
        // Handle different response structures
        let cohortData = [];
        let total = 0;
        
        if (response.content) {
          // Paginated response
          cohortData = response.content;
          total = response.totalElements || 0;
          setHasMore(!response.last);
        } else if (Array.isArray(response)) {
          // Array response
          cohortData = response;
          total = response.length;
          setHasMore(false);
        } else if (response?.content) {
          cohortData = response.content;
          total = response.totalElements || 0;
          setHasMore(!response.last);
        } else if (response) {
          cohortData = response;
          total = response.length || 0;
          setHasMore(false);
        }

        if (pageNum === 0) {
          setAssortmentCohortMetaDataList(cohortData);
        } else {
          setAssortmentCohortMetaDataList(prev => [...prev, ...cohortData]);
        }
        
        setTotalCount(total);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error("API Error:", err);
        setError(err.message || "Failed to load cohort data");
        setLoading(false);
      }
    );
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    fetchCohortList("", 0);
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchCohortList(searchTerm, nextPage);
  };

  return (
    <CohortAssortmentListComponent
      assortmentCohortMetaDataList={assortmentCohortMetaDataList}
      handleWarehouseClick={handleWarehouseClick}
      loading={loading}
      error={error}
      searchTerm={searchTerm}
      onSearchChange={handleSearchChange}
      onClearSearch={handleClearSearch}
      totalCount={totalCount}
      hasMore={hasMore}
      onLoadMore={handleLoadMore}
    />
  );
};

function mapStateToProps(state) {
  return {
    state
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(CohortAssortmentListContainer);